import React, { useState, useEffect } from 'react';
import { Plus } from 'lucide-react';
import { getReconciliations, createReconciliation } from '../../api/erp';
import { toast } from 'react-toastify';
import BlurredValue from '../../components/common/BlurredValue';

const BankReconciliationPage = () => {
  const [recons, setRecons] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({ account_id: 1, statement_date: '', statement_balance: '', ledger_balance: '' });

  useEffect(() => { fetch(); }, []);
  const fetch = async () => { try { setRecons(await getReconciliations()); } catch {} };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try { await createReconciliation(formData); toast.success('Reconciled'); setShowModal(false); fetch(); } catch { toast.error('Error'); }
  };

  return (
    <div className="p-6">
      <div className="flex justify-between mb-6">
        <h1 className="text-2xl font-bold">Bank Reconciliation</h1>
        <button onClick={() => setShowModal(true)} className="bg-black text-white px-4 py-2 rounded flex gap-2"><Plus size={16}/> New Recon</button>
      </div>
      <div className="bg-white rounded shadow overflow-hidden">
        <table className="w-full">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left">Date</th>
              <th className="px-6 py-3 text-left">Account</th>
              <th className="px-6 py-3 text-right">Statement Bal.</th>
              <th className="px-6 py-3 text-right">Ledger Bal.</th>
              <th className="px-6 py-3 text-right">Difference</th>
            </tr>
          </thead>
          <tbody>
            {recons.map(r => (
              <tr key={r.id} className="border-t">
                <td className="px-6 py-4">{new Date(r.statement_date).toLocaleDateString()}</td>
                <td className="px-6 py-4">{r.account_name || 'Bank Account'}</td>
                <td className="px-6 py-4 text-right"><BlurredValue value={r.statement_balance} /></td>
                <td className="px-6 py-4 text-right"><BlurredValue value={r.ledger_balance} /></td>
                <td className={`px-6 py-4 text-right font-bold ${parseFloat(r.difference) !== 0 ? 'text-red-500' : 'text-green-500'}`}>
                  <BlurredValue value={r.difference} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {showModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4">
          <div className="bg-white rounded p-6 w-full max-w-md">
            <h2 className="text-xl font-bold mb-4">New Reconciliation</h2>
            <form onSubmit={handleSubmit} className="space-y-4">
              <input type="date" className="w-full border p-2 rounded" onChange={e => setFormData({...formData, statement_date: e.target.value})} required />
              <input type="number" placeholder="Statement Balance" className="w-full border p-2 rounded" onChange={e => setFormData({...formData, statement_balance: e.target.value})} required />
              <input type="number" placeholder="Ledger Balance" className="w-full border p-2 rounded" onChange={e => setFormData({...formData, ledger_balance: e.target.value})} required />
              <div className="flex gap-2 justify-end">
                <button type="button" onClick={() => setShowModal(false)} className="px-4 py-2 border rounded">Cancel</button>
                <button type="submit" className="px-4 py-2 bg-black text-white rounded">Save</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default BankReconciliationPage;
